	"use strict";
	
	var $j = jQuery.noConflict();
	var cookieName = "wishlistList";

/*submenu, align center button Launch*/
$j( document ).ready(function(){
  if($j(".image-links-layout .figure").length > 0) {
    $j(".image-links-layout .figure").each(function(){
      var $this = $j(this);
      var $obj = $this.find(".btn");
      $obj.css("left", parseInt(($this.innerWidth() - $obj.innerWidth())/2) + "px");
    })
  }
});
/**/

$j(window).resize(function(){
  var $cboxClose = $j("#cboxClose");
  if($cboxClose.length && window.innerWidth > 1024 ) {
    $j("#cboxClose").trigger("click");
  }
})

$j(window).bind("initWishlistNoCustomer", initWishlistNoCustomer);
initWishlistNoCustomer();
function initWishlistNoCustomer() {
  updateWishlistButtons();
  initWishlistButtons();
}
function initWishlistButtons() {
  if($j(".add-in-wishlist-js").length == 0) {
  	return false;
  }
}

$j(document).on("click", '.add-in-wishlist-js', function(event) {
      try
      {
        var id = $j(this).attr('my-handle');
        if($j.cookie(cookieName) == null) {
          var str = id;
        } else {
          if($j.cookie(cookieName).indexOf(id) == -1) {
            var str = $j.cookie(cookieName) + '__' + id;
          }
        }
        $j.cookie(cookieName, str, {expires:7, path:'/'});
        if ($j(this).attr('nj-wishlist') != "active") {
          showMessage();
          setTimeout(hideMessage, 6000);
        }
   
        
        var _parent = $j(this).parent().parent();
        _parent.find('.default-wishbutton').hide();
        _parent.find('.added-wishbutton').show();
        updateWishlistButtons();
      }
      catch (err) {
            console.log(err);
      } // ignore errors reading cookies
    });
function showMessage() {
  jQuery('#modalAddToWishlist').modal("toggle");
  jQuery('#newCompareModal').css("z-index", "777777");
}
function hideMessage() {
  jQuery('#modalAddToWishlist').modal('hide');
}
function updateWishlistButtons() {
  try
  {
    if($j.cookie(cookieName) != null && $j.cookie(cookieName) != '__' && $j.cookie(cookieName) != '') {
      var str = String($j.cookie(cookieName)).split("__");
      for (var i=0; i<str.length; i++) {
        if (str[i] != '') {
          if ($j('.defbtn'+str[i]).length) {
            var _parent = $j('.defbtn'+str[i]).parent();
                _parent.find('.added-wishbutton').show();
                $j('.defbtn'+str[i]).hide();
          }
        }
      }
    }
  }
  catch (err) {}
//  console.log('ok');
}




if ($j("#rightColumn").length > 0) {
  $j(window).resize(function(){
    var w = window.innerWidth;
    if (w < 992) {
      if ($j("#leftColumn").children().length && $j("#rightColumn").children().length == 0) {return false;}
      var detach = $j("#rightColumn .sidebar-content").detach();
      $j("#leftColumn").append(detach);
    }
    else {
      if ($j("#rightColumn").children().length > 1) {return false;}
      var detach = $j("#leftColumn .sidebar-content").detach();
      $j("#rightColumn").append(detach);
    }
  });
  $j(window).trigger('resize');
}




    if ($j(".image-links-prototypes").length) {
      $j(".image-links-prototypes").each(function(){$j(this).parent().addClass("image-links-prototypes");});
    }


    function changeInputNameCartPage() {
      var name= "updates[]";
      if ($j(window).width() > 767) {
        $j(".input-mobile").attr("name", "");
        $j(".input-desktop").attr("name", name);
      }
      else {
        $j(".input-mobile").attr("name", name);
        $j(".input-desktop").attr("name", "");
      }
    }
    if ($j(".input-mobile").length && $j(".input-desktop").length ) {
      changeInputNameCartPage();
      $j(window).resize(changeInputNameCartPage);
    }

	function debouncer(func, timeout) {
	    var timeoutID, timeout = timeout || 500;
	    return function() {
	        var scope = this,
	            args = arguments;
	        clearTimeout(timeoutID);
	        timeoutID = setTimeout(function() {
	            func.apply(scope, Array.prototype.slice.call(args));
	        }, timeout);
	    }
	}

	// Slide Column

    function slideColumn(){
      if ($j('#leftColumn').length > 0) {
        $j(window).resize(function(){
          if(window.innerWidth < 992 ) {
          	filtersHeight();
          } else {
          	$j('#leftColumn').removeAttr('style');
          }
        });
        
      	$j('.slide-column-close').addClass('position-fix');
        $j('.slide-column-open').on('click', function(e){
          e.preventDefault();
          $j('#leftColumn').addClass('column-open');
          $j('body').css("top", -$j('body').scrollTop());
          $j('body').addClass("no-scroll").append( '<div class="modal-filter"></div>');	
          if ($j(".modal-filter").length > 0) {	        	
			  $j(".modal-filter").click(function(){
			   $j('.slide-column-close').trigger('click');
			  })
			} 
        });
        $j('.slide-column-close').on('click', function(e){
          e.preventDefault();
          $j("#leftColumn").removeClass('column-open');
          $j(".modal-filter").unbind();
          $j(".modal-filter").remove();
          var top = parseInt($j('body').css("top").replace("px", ""))*-1;
          $j('body').removeAttr("style");
          $j('body').removeClass("no-scroll");
          $j('body').scrollTop(top);
        });
      } 
    }
	
    function filtersHeight(){
      var $obj = $j('#leftColumn');
      var w_height = window.innerHeight;
      var o_height = $obj.outerHeight();
      var delta = parseInt(w_height - o_height);
      if(delta < 0) {
        $obj.css({"max-height": o_height + delta, "overflow": "auto", "overflow-x": "hidden" });
      }
    }
	
	// Countdown

	function countDown(){
	    if ($j("#countdown1").length > 0) {
	        $j('#countdown1').countdown({
	            until: new Date(2015, 12, 1)
	        });
	    }	
	}

	// Product Carousel
	
	function productCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

		var windowW = window.innerWidth || $j(window).width();

		var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
		var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
		var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
		var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
		var slidesToShowXs = (numberXs > 0) ? numberXs : 1;
		
		var carousel = carousel;
		var speed = 500;
			
		if (carousel.parent().find('.carousel-products__button').length > 0) {
	
				carousel.slick({
						prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
						nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
						dots: true,
						slidesToShow: slidesToShowXl,
						slidesToScroll: slidesToShowXl,
		                infinite: false,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowLg
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowMd
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowSm
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
					});
			}
			else {
				carousel.slick({
					slidesToShow: slidesToShowXl,
					slidesToScroll: 1,
					speed: speed,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowLg
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowMd
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowSm
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
				});
			}
		

		fixCarouselHover(carousel);

	};

	// Product productBigCarousel
	
	function productBigCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

		var windowW = window.innerWidth || $j(window).width();

		var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
		var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
		var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
		var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
		var slidesToShowXs = (numberXs > 0) ? numberXs : 1;
		
		var carousel = carousel;
		var speed = 500;
			
		if (carousel.parent().find('.carousel-products__button').length > 0) {
	
				carousel.slick({
						prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
						nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
						dots: true,
						slidesToShow: slidesToShowXl,
						slidesToScroll: slidesToShowXl,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowXs
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowXs
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowXs
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
					});
			}
			else {
				carousel.slick({
					slidesToShow: slidesToShowXl,
					slidesToScroll: 1,
					speed: speed,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowXs
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowXs
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowXs
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
				});
			}
		

		fixCarouselHover(carousel);

	};

	// Carousel Product Mobile only	
	
	function mobileOnlyCarousel() {

		var windowW = window.innerWidth || $j(window).width();
	
		var carouselMobileOnly = $j('.carousel-products-mobile');
		
		if (windowW < 480) {
			$j('.carousel-products-mobile').slick({
				slidesToShow: 1,
				slidesToScroll: 1
			});
		}
		$j(window).resize(debouncer(function(e) {
		
			var currentW = window.innerWidth || $j(window).width();
			
			if (currentW < 480) {
              if(carouselMobileOnly && carouselMobileOnly.length) {
                carouselMobileOnly.slick({
                  slidesToShow: 1,
                  slidesToScroll: 1
                });
              }
			} else {
				if (carouselMobileOnly.hasClass('slick-initialized')){
					carouselMobileOnly.slick('unslick');
				}
			}
		}))
	};
	
	// Category carousel	
	
	function bannerCarousel(carousel) {
	    carousel.slick({
	        infinite: true,
	        dots: false,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
				breakpoint: 768,
				settings: {
	                slidesToShow: 2,
	                slidesToScroll: 2
					}
				}, 
				{
	            breakpoint: 480,
	            settings: {
	                slidesToShow: 1,
	                slidesToScroll: 1
	            }
	        }]
	    });
	}	
	
	// Category carousel	
	
	function bannerCarouselShort(carousel) {
	    carousel.slick({
	        infinite: true,
	        dots: false,
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        responsive: [{
				breakpoint: 1200,
				settings: {
	                slidesToShow: 2,
	                slidesToScroll: 2
					}
				}, 
				{
	            breakpoint: 480,
	            settings: {
	                slidesToShow: 1,
	                slidesToScroll: 1
	            }
	        }]
	    });
	}

	// Blog carousel	
	
	function blogCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

		var windowW = window.innerWidth || $j(window).width();

		var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
		var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
		var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
		var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
		var slidesToShowXs = (numberXs > 0) ? numberXs : 1;
		
		var carousel = carousel;
		var speed = 500;
			
		if (carousel.parent().find('.carousel-products__button').length > 0) {
	
				carousel.slick({
						prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
						nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
						dots: false,
						infinite: true,
						slidesToShow: slidesToShowXl,
						slidesToScroll: slidesToShowXl,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowLg
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowMd
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowSm
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
					});
			}
			else {
				carousel.slick({
					slidesToShow: slidesToShowXl,
					slidesToScroll: 1,
					speed: speed,
						responsive: [{
							breakpoint: 1770,
							settings: {
								slidesToShow: slidesToShowLg,
								slidesToScroll: slidesToShowLg
							}
						},{
							breakpoint: 992,
							settings: {
								slidesToShow: slidesToShowMd,
								slidesToScroll: slidesToShowMd
							}
						}, {
							breakpoint: 768,
							settings: {
								slidesToShow: slidesToShowSm,
								slidesToScroll: slidesToShowSm
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: slidesToShowXs,
								slidesToScroll: slidesToShowXs
							}
						}]
				});
			}
		


	};

	
	// bannerAsid carousel	
	
	function bannerAsid(carousel) {
	    carousel.slick({
	        infinite: true,
	        dots: true,
	        arrows: false,
	        slidesToShow: 1,
	        slidesToScroll: 1
	    });
	}

	// bannerAsid carousel	
	
	function testimonialsAsid(carousel) {
	    carousel.slick({
	        infinite: true,
	        dots: true,
	        arrows: false,
	        slidesToShow: 1,
	        slidesToScroll: 1
	    });
	}

	// Brands carousel	
	
	function brandsCarousel(carousel) {
	    carousel.slick({
	        infinite: false,
	        dots: false,
	        slidesToShow: 6,
	        slidesToScroll: 6,
	        responsive: [{
				breakpoint: 1770,
				settings: {
	                slidesToShow: 4,
	                slidesToScroll: 4
					}
				},{
				breakpoint: 1199,
				settings: {
	                slidesToShow: 3,
	                slidesToScroll: 3
					}
				},{
				breakpoint: 768,
				settings: {
	                slidesToShow: 3,
	                slidesToScroll: 3
					}
				}, 
				{
	            breakpoint: 480,
	            settings: {
	                slidesToShow: 2,
	                slidesToScroll: 2
	            }
	        }]
	    });
	}
	
	// Vertical carousel	
	
	function verticalCarousel(carousel, slidesToShow) {
		var slidesToShow = (slidesToShow > 0) ? slidesToShow : 2;
	    carousel.slick({
	        infinite: false,
	        dots: false,
	        slidesToShow: slidesToShow,
	        slidesToScroll: slidesToShow,
			vertical: true
	    });
	}
	
	// Product thumbnails carousel
	
	function thumbnailsCarousel(carousel) {
		carousel.slick({
			infinite: true,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}]
		});
	}
	
	// Fix z-index problem on carousel hover
	
	function fixCarouselHover(carousel) {
		carousel.find('.slick-slide').bind( "mouseenter mouseleave",
                function( event ){
                    $j(this).closest('.slick-slider').toggleClass('hover');
                }
        );			
	};
	
// Elevate Zoom

 function elevateZoom() {

  var windowW = window.innerWidth || document.documentElement.clientWidth;
  $j('.product-zoom').imagesLoaded(function() {
  if ($j('.product-zoom').length) {

      var zoomPosition
    if ( $j('html').css('direction').toLowerCase() == 'rtl' ) {
     zoomPosition = 11;
    }
    else {
     zoomPosition = 1
    }


   if (windowW > 767) {
    $j('.product-zoom').elevateZoom({
     //zoomWindowHeight: $j('.product-zoom').height(), // if zoom container must be as image height
     zoomWindowWidth: $j('.product-zoom').width()- 60,
     zoomWindowHeight: $j('.product-zoom').width() - 60,
     gallery: "smallGallery",
     galleryActiveClass: 'active',
     zoomWindowPosition : zoomPosition
    })
   } else {
    $j(".product-zoom").elevateZoom({
     gallery: "smallGallery",
     zoomType: "inner",
     galleryActiveClass: 'active',
     zoomWindowPosition : zoomPosition
    });
   }
  }
  })
  
  
  $j('.product-main-image > .product-main-image__zoom ').bind('click', function(){
  
   
    galleryObj = [];
    current = 0;
    itemN = 0;
    
   if ($j('#smallGallery').length){
    console.log('1');
    $j('#smallGallery li a').not('.video-link').each(function() {
     if ($j(this).hasClass('active')) {
      current = itemN;
     }
     itemN++;
     var src = $j(this).data('zoom-image'),
      type = 'image';
      image = {};
      image ["src"] = src;
      image ["type"] = type;

     galleryObj.push(image);
    });
   }
   
   else {
    console.log('2');
     itemN++;
     var src = $j(this).parent().find('.product-zoom').data('zoom-image'),
      type = 'image';
      image = {};
      image ["src"] = src;
      image ["type"] = type;

     galleryObj.push(image);
   }

   $j.magnificPopup.open({
    items: galleryObj,
    gallery: {
     enabled: true,
    }
   }, current);
   
  });
  
  var  prevW = windowW;


  $j(window).resize(debouncer(function(e) {
   var currentW = window.innerWidth || $j(window).width();

   if (currentW != prevW) {
    // start resize events

    $j('.zoomContainer').remove();
    $j('.elevatezoom').removeData('elevateZoom');

    if ($j('.product-zoom').length) {
     if (currentW > 767) {
      $j('.product-zoom').elevateZoom({
       zoomWindowHeight: $j('.product-zoom').height(),
       gallery: "smallGallery"
      })
     } else {
      $j(".product-zoom").elevateZoom({
       gallery: "smallGallery",
       zoomType: "inner"
      });
     }
    }  
    
    
    // end resize events  
   }


   prevW = window.innerWidth || $j(window).width();


  }));
 }

 // Elevate Zoom

	function elevateZoom1() {

		var currentW = window.innerWidth || $j(window).width();
		if (currentW > 767) {
			if ($j('.product-zoom1').length) {
				 $j('.product-zoom1').elevateZoom({
				    zoomType: "inner",
					cursor: "crosshair",
					zoomWindowFadeIn: 300,
					zoomWindowFadeOut: 300
				}); 
			}
		}

	}

	// Set Product Size 

	function setProductSize() {
		
	    var windowW = window.innerWidth || $j(window).width();
		
	    if (windowW > 767) {
	        $j('.product').each(function() {
	            var productH = $j(this).outerHeight();
	            $j(this).css({
	                'min-height': productH + 'px'
	            });
	            $j(this).find('.product__inside').addClass('pos-abs');
	        });
	    }
	
	    $j(window).resize(function(e) {
	        $j('.product').each(function() {
	            $j(this).css({
	                'min-height': ''
	            })
	            $j(this).find('.product__inside__info').css({
	                'height': '0'
	            })
	            $j(this).find('.product__inside').removeClass('pos-abs');
	        })
			
			var timeout;
			clearTimeout(timeout);
			timeout = setTimeout(function() {
				var currentW = window.innerWidth || $j(window).width();
				$j('.product').each(function() {
					$j(this).find('.product__inside__info').css({
						'height': ''
					});
					if (currentW > 767) {
						var productH = $j(this).outerHeight();
						$j(this).css({
							'min-height': productH + 'px'
						});
						$j(this).find('.product__inside').addClass('pos-abs');
					}
				});
			}, 1000);				
	    })
	};

	
	
	// menu click go URL
	
	function navbarClick() {
		
		var windowW = window.innerWidth || $j(window).width();
		// mobile menu off width
		if (windowW > 1025) {
			$j('.navbar .dropdown > a').on('click', function(){
				location.href = this.href;
				return false
			});
		}
		
	};
	

	// Set Product Page Prev-Next Arrows Position at center of the product image 

	function setProductArrows() {
		var windowW = window.innerWidth || $j(window).width();
		var setArrowPos = function(windowW) {
			if (windowW > 1199) {
				var imgH = $j('.product-main-image img').height();
				$j('#productPrevNext > a').css({'top': imgH/2 + 'px'});
			}
		}
		
		setArrowPos(windowW);
		
		$j(window).resize(debouncer(function(e) {
			var currentW = window.innerWidth || $j(window).width();
			setArrowPos(currentW);
		}))
	};

	
	// Set Mobile Carousel Arrows Position at center of the product image 

	function setCarouselArrows() {

	    var windowW = window.innerWidth || $j(window).width();
		
		var setArrowPos = function(windowW) {
			if (windowW < 480) {
				if ($j('.carousel-products-mobile.slick-initialized').length || $j('.carousel-products.slick-initialized').length){
					$j('.carousel-products-mobile').each(function() {
						var imgH = $j(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
						$j(this).find('.slick-arrow').css({'top': imgH/2 + 'px'});
					})					
					$j('.carousel-products').each(function() {
						if ($j(this).parent().parent().find('.carousel-products__button').length > 0) {
							var imgH = $j(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
							var titleH = $j(this).parent().parent().find('.title-with-button').height();
							$j(this).parent().parent().find('.carousel-products__button').css({'top': imgH/2 + titleH + 'px'});
						}
					})
				}
			} else {
				$j('.carousel-products').each(function() {
					if ($j(this).parent().parent().find('.carousel-products__button').length > 0) {
						$j(this).parent().parent().find('.carousel-products__button').css({'top': ''});
					}
					else {
						var imgH = $j(this).find('.slick-list .slick-track .slick-slide:first-child img').height();
						$j(this).find('.slick-arrow').css({'top': imgH/2 + 'px'});
					}
				})
			}		
		}
		
		setArrowPos(windowW);
		
		$j(window).resize(debouncer(function(e) {
			var currentW = window.innerWidth || $j(window).width();
			setArrowPos(currentW);
		}))
	};

	// Set mobile dropdowns width
	
	function setMobileDrop() {
	
	    var windowW = $j('body').innerWidth();
		
		var setDropsW;
		
		setDropsW = function(windowW) {
		// mobile menu off width
			if (windowW < 1025) {
				$j('.dropdown-menu--xs-full').each(function() {
					$j(this).css({'width': windowW + 'px'});
				})			
			}
			else {
				$j('.dropdown-menu--xs-full').each(function() {
					$j(this).css({'width': ''});
				})	
			}
		}
				
		setDropsW(windowW);
		
		$j(window).resize(debouncer(function(e) {
			var currentW = $j('body').innerWidth();
			setDropsW(currentW);
		}))
			
	};
	
	// DropDown Close
	
	function handlerDropDownClose() {
	
		$j('.dropdown-menu__close').on('click', function(e) {
			e.preventDefault();
			$j(this).closest('.dropdown.open .dropdown-toggle').dropdown('toggle');
		});
			
	};
	
	// Search DropDown
	
	function searchDropDown() {
	
		$j('.search__open').on('click', function(e) {
			e.preventDefault();
			$j(this).parent('.search').addClass('open');
			$j(this).next('.search-dropdown').addClass('open');
			$j('header .badge').addClass('badge--hidden');
		});		
		$j('.search__close').on('click', function(e) {
			e.preventDefault();
			$j(this).closest('.search').removeClass('open');
			$j(this).closest('.search-dropdown').removeClass('open');
			$j('header .badge').removeClass('badge--hidden');
		});
			
	};	
	
	// Mobile footer collapse

	function footerCollapse() {

		$j('.mobile-collapse__title').on('click', function(e) {
			e.preventDefault;
			$j(this).parent('.mobile-collapse').toggleClass('open');
		})

	};
	
	
    $j(window).bind('reinitSliderInProduct', productInsideCarousel);
	// Product inside carousel
	function productInsideCarousel() {
      $j(".product__inside__carousel").each(function () {
        var $this = $j(this);
        if(!$this.hasClass('isInit')) {
          $this.addClass('isInit');
          $this.carousel({
            interval: false
          })
          $this.find('.carousel-control.next').on('click', function() {
            $this.carousel('next');
          });		
          $this.find('.carousel-control.prev').on('click', function() {
            $this.carousel('prev');
          });
        }
      });
	};
	
	// Category list collapse saut
	
// 	function expanderList() {
// 		$j('.expander-list .expander').each(function() {
// 			if ($j(this).parent('li').hasClass('active')){
// 				$j(this).next('ul').slideDown(0);
// 				$j(this).parent().addClass('open');
// 			}
// 		})
// 		$j(".expander-list .expander").on('click', function(e) {
// 			e.preventDefault;
// 			var speed = 300;
// 			var thisItem = $j(this).parent(),
// 				nextLevel = $j(this).next('ul');
// 			if (thisItem.hasClass('open')){
// 				thisItem.removeClass('open');
// 				nextLevel.slideUp(speed);
// 			}
// 			else {
// 				thisItem.addClass('open');
// 				nextLevel.slideDown(speed);
// 			}
// 		})
// 	};
	
function expanderList()
{
	$j(".expander-list .expander").each(function ()
	{
		$j(this).parent("li").hasClass("active") && ($j(this).next("ul").slideDown(0), $j(this).parent().addClass("open"))
	}), $j(".expander-list .expander, .name").on("click", function (e)
	{
		e.preventDefault;
		var t = $j(this).parent(),
            o = $j(this).next("ul");
		t.hasClass("open") ? (t.removeClass("open"), o.slideUp(300)) : (t.addClass("open"), o.slideDown(300))
	})
}


	// Collapse Block (left column in listing)

// 	function collapseBlock() {
// 		$j('.collapse-block__content').each(function() {
// 			if ($j(this).parent('.collapse-block').hasClass('open')){
// 				$j(this).slideDown(0);
// 			}
// 		})
// 		$j('.collapse-block__title').on('click', function(e) {
// 			e.preventDefault;
// 			var speed = 300;
// 			var thisItem = $j(this).parent(),
// 				nextLevel = $j(this).next('.collapse-block__content');
// 			if (thisItem.hasClass('open')){
// 				thisItem.removeClass('open');
// 				nextLevel.slideUp(speed);
// 			}
// 			else {
// 				thisItem.addClass('open');
// 				nextLevel.slideDown(speed);
// 			}
// 		})
// 	};
function collapseBlock()
{
	$j(".collapse-block__content").each(function ()
	{
		$j(this).parent(".collapse-block").hasClass("open") && $j(this).slideDown(0)
	}), $j(".collapse-block__title").on("click", function (e)
	{
		e.preventDefault;
		var t = $j(this).parent(),
			o = $j(this).next(".collapse-block__content");
		t.hasClass("open") ? (t.removeClass("open"), o.slideUp(300)) : (t.addClass("open"), o.slideDown(300))
	})
}

	// Price Slider initialize

	function priceSlider() {

		if ($j('.price-slider').length) {
		
			var priceSlider = document.getElementById('priceSlider');

			noUiSlider.create(priceSlider, {
				start: [100, 900],
				connect: true,
				step: 1,
				range: {
					'min': 0,
					'max': 1000
				}
			});
			
			var inputPriceMax = document.getElementById('priceMax');
			var inputPriceMin = document.getElementById('priceMin');

			priceSlider.noUiSlider.on('update', function( values, handle ) {

				var value = values[handle];

				if ( handle ) {
					inputPriceMax.value = value;
				} else {
					inputPriceMin.value = value;
				}
			});

			inputPriceMax.addEventListener('change', function(){
				priceSlider.noUiSlider.set([null, this.value]);
			});			
			inputPriceMin.addEventListener('change', function(){
				priceSlider.noUiSlider.set([this.value, null]);
			});
		};
	}
	
	// Listing view mode

	function listingModeToggle() {		
		$j('a.link-row-view').on('click', function(e) {
			e.preventDefault();
			$j(this).addClass('active');
			$j('a.link-grid-view').removeClass('active');
			$j('.product-listing').addClass('row-view');
		})
		$j('a.link-grid-view').on('click', function(e) {
			e.preventDefault();
			$j(this).addClass('active');
			$j('a.link-row-view').removeClass('active');
			$j('.product-listing').removeClass('row-view');
		})
	}
	
		
// Init for all template pages




//=========== back-to-top

function backToTop() {
	if($j(".back-to-top-n").length > 0) {
		$j('.back-to-top-n').click(function() {
			$j('html, body').animate({scrollTop: 0},500);
			return false;
		});
		$j(window).scroll(function () {
			if($j(window).scrollTop() > 500) {
				$j(".back-to-top-n").stop(true.false).fadeIn(110)
			} else {
				$j(".back-to-top-n").stop(true.false).fadeOut(110)
			}
		});
	}
}

function DocHeight() {
	return $j(document).height();
}

function backToDown() {
	if($j(".back-to-down").length > 0) {
		$j('.back-to-down').click(function() {
			$j('html, body').animate({scrollTop: DocHeight()},500);
			return false;
		});
		$j(window).scroll(function () {
			if($j(window).scrollTop() > 500) {
				$j(".back-to-down").stop(true.false).fadeIn(110)
			} else {
				$j(".back-to-down").stop(true.false).fadeOut(110)
			}
		});
	}
}


//=========== stuck-nav
var HeaderTop = '';
function stuckNav(){
  if ($j(".stuck-nav").length > 0) {
    HeaderTop = $j('.header-layout-02').length && window.innerWidth > 1024 ? $j('#pageContent').offset().top : $j('.stuck-nav').offset().top;
    $j(window).scroll(function(){
      checkStickyPosition();
      $j('.header-layout-02').length ? stickNav() : false;
    });
    $j(window).resize(function(){
      HeaderTop = $j('#pageContent').offset().top;
      checkStickyPosition();
      $j('.header-layout-02').length ? $j( '.stuck-nav' ).length && window.innerWidth <= 1024 ? $j( '.stuck-nav' ).show() : stickNav() : false;
    });
    checkStickyPosition();
  }
}
function checkStickyPosition(){
  $j(window).scrollTop() > HeaderTop ? $j('.stuck-nav').addClass('fixedbar') : $j('.stuck-nav').removeClass('fixedbar');
 $j('.stuck-nav').hasClass('fixedbar') ? $j('.text-left .toggle-menu .dropdown-menu').css("display", "none") : $j(".stuck-nav .toggle-menu .dropdown-menu").css("display", "none");
  //$j(window).scrollTop() > HeaderTop ? $j('.fixedbar .nj_wishlist_row_label').css('display', 'none') : false;
}
function stickNav() {
  if($j( '.stuck-nav' ).length && window.innerWidth > 1024) {
    $j( window ).scrollTop() > $j('#header').innerHeight() ? $j( '.stuck-nav' ).show() : $j( '.stuck-nav' ).hide();
  }
}

//=========== click on cart(header-layout-06)
jQuery(function($j) {

    "use strict";

     if ($j(".header-layout-06 ").length > 0) {
     	 $j(".header-layout-06 .icon-search").click(function() {
	        $j(".header-layout-06 .alignment-extra").toggleClass('width-extra');
	    });
	     $j(".header-layout-06 .icon-close").click(function() {
	        $j(".header-layout-06 .alignment-extra").toggleClass('width-extra');
	    });
     }
});

//=========== click on cart
function cartSlideIni(){
  if ($j("header .cart").length > 0) {
    $j('header .cart .dropdown-toggle').on('click', function(e){
      if($j("header .cart .dropdown-menu ul li").length) {
        $j("header .cart .dropdown").toggleClass('open');
        headerCartSize();
      }
      e.preventDefault();
    });
    $j('header .cart .cart__close').on('click', function(e){
      $j("header .cart .dropdown").toggleClass('open');
      e.preventDefault();
    });						
  }
}





// Blog carousel
function blogPostSlider(){
	"use strict";
    if ($j(".blogPostSlider").length > 0) {
        $j('.blogPostSlider').slick({
		  infinite: true,
		  slidesToShow: 1
		});
    }	
}


jQuery(function($j) {	
  "use strict";
  if ($j('.gallery').length) {
    $j('.gallery .zomm-gallery').magnificPopup({
      type:'image',
      gallery:{
        enabled:true
      }

    });
  }

});
jQuery(function($j) {	
  "use strict";

  var newSelection = "";

  $j(".filter-nav a").click(function(){
    $j("#all-filter-content").hide(0);
    $j("#all-filter-content").fadeIn(500);

    $j(".filter-nav a").removeClass("current");
    $j(this).addClass("current");

    newSelection = $j(this).attr("rel");

    $j(".filter-content-item").not("."+newSelection).fadeOut();
    $j("."+newSelection).fadeIn();

    $j("#all-filter-content").fadeIn(0);

  });

});

function menu_popup(){
	"use strict";
    if ($j(".mainMenu").length > 0) {
	        $j("header .mainMenu .navbar-nav > li").on('mouseenter mouseleave', function (e) {
	        if ($j('ul', this).length) {
	            var elm = $j('ul:first', this);
	            var off = elm.offset();
	            var l = off.left;
	            var w = elm.width();
	            var docH = $j(".container").height();
	            var docW = $j(".container").width();

	            var isEntirelyVisible = (l + w <= docW);

	            if (!isEntirelyVisible) {
	                $j('ul',this).addClass('popup-left');
	            } else {
	                $j('ul',this).removeClass('popup-left');
	            }
	        }
	    });
        
    }	
}




	
	





$j(document).ready(function() {
	
	"use strict";
	
	navbarClick();
	countDown();
	setMobileDrop();
	handlerDropDownClose();
	searchDropDown();
	footerCollapse();
	productInsideCarousel();
	expanderList();
	collapseBlock();
	priceSlider();
	slideColumn();
	backToTop();
	backToDown();
	stuckNav();
	blogPostSlider();
  	cartSlideIni();
	inputCounter();
  	menu_popup();

	// Remove Loader
	$j('body').addClass('loaded');
	
	
	
	var timeout1;
	clearTimeout(timeout1);
	timeout1 = setTimeout(function() {
		//setProductSize();
	}, 500);	
	
	var timeout2;
	clearTimeout(timeout2);
	timeout2 = setTimeout(function() {
		// Resize elements	
		setCarouselArrows();
		if ($j('#productPrevNext').length) {
			setProductArrows();	
		}
	}, 2000);		

	


})

// Reinit when resize

$j(window).resize(debouncer(function(e) {
  elevateZoom1();
  menu_popup();
}))





//=========== Gallery 

jQuery(function($j) {

  "use strict";

  var gallery = $j('.gallery');


  gallery.imagesLoaded(function() {
    if (gallery.length) {
      gallery.isotope({
        itemSelector: '.gallery__item',
        isResizeBound: false,
        masonry: {
          isFitWidth: true
        }
      });
      setGallerySize();
    }	
  })


  function setGallerySize() {
    var windowW = window.innerWidth || $(window).width(),
        itemsInRow = 1;
    if (windowW > 1199) {
      itemsInRow = 5;
    } else if (windowW > 991) {
      itemsInRow = 4;
    } else if (windowW > 767) {
      itemsInRow = 3;
    } else if (windowW > 480) {
      itemsInRow = 2;
    }
    var containerW = gallery.parent('.container').width(),
        galleryW = containerW / itemsInRow;

    gallery.find('.gallery__item').each(function() {
      if ($j(this).hasClass('gallery__item--double') && windowW > 767 ) {
        $j(this).css({
          width: galleryW*2 + 'px',
        });
      }
      else {
        $j(this).css({
          width: galleryW + 'px'
        });
      }
    });
    var galleryH = gallery.find('.gallery__item:not(.gallery__item--double)').height();
    gallery.find('.gallery__item').each(function() {
      $j(this).css({
        height: ''
      });
      if ($j(this).hasClass('gallery__item--double') && windowW > 767) {
        $j(this).css({
          height: galleryH*2 + 'px'
        });
      }
    });
    gallery.isotope('layout');
  }



  var prevW = window.innerWidth || $j(window).width();

  $j(window).resize(debouncer(function(e) {
    if (gallery.length) {			
      var currentW = window.innerWidth || $j(window).width();
      if (currentW != prevW) {
        // start resize events	
        setGallerySize();
        // end resize events		
      }
      prevW = window.innerWidth || $j(window).width();
    }
  }));



});

//=========== click on toggle-menu(icon toggle menu)
jQuery(function($j) {
    "use strict";
  if($j(".toggle-menu").length) {
    $j(".text-left .toggle-menu .icon, .text-left .toggle-menu .close").click(function() {
        $j(".text-left .toggle-menu .dropdown-menu").fadeToggle();
      	
    });
    
    $j(".stuck-nav .toggle-menu .icon, .stuck-nav .toggle-menu .close").click(function() {
      $j('.header-layout-07 .text-left .toggle-menu .dropdown-menu').css("display", "none");
      $j(".stuck-nav .toggle-menu .dropdown-menu").fadeToggle();
    
  	});
  }
});

// Image background

jQuery(function($j) {

    "use strict";
 if ($j('.image-bg').length) {
  $j('.image-bg').each(function() {
   var attr = $j(this).attr('data-image');  
   $j(this).css({'background-image': 'url('+attr+')'});
  })
 }

});

// Parallax

jQuery(function($j) {

  "use strict";
  if ($j('.content--parallax').length) {
    $j('.content--parallax').each(function() {
      var attr = $j(this).attr('data-image');  
      $j(this).css({'background-image': 'url('+attr+')'}).parallax("50%", 0.01);
    })
  }


});

// input-counter

function inputCounter(){
  if ($j(".input-counter").length > 0) {
    $j('.minus-btn').click(function () {
      var $jinput = $j(this).parent().find('input');
      var count = parseInt($jinput.val()) - 1;
      count = count < 1 ? 1 : count;
      $jinput.val(count);
      $jinput.change();
      return false;
    });
    $j('.plus-btn').click(function () {
      var $jinput = $j(this).parent().find('input');
      $jinput.val(parseInt($jinput.val()) + 1);
      $jinput.change();
      return false;
    });
  } 
}

//slider on product-fields
function sliderNoZoom(){
  if ($j(".slider-no-zoom").length > 0) {
    $j('.slider-product-large').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      centerPadding: '40px',
      infinite: true,
      asNavFor: '.slider-product-small'
    });
    $j('.slider-product-small').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      asNavFor: '.slider-product-large',
      dots: true,
      centerPadding: '40px',
      focusOnSelect: true
    });
  }		    
}

//mobile menu 
jQuery(function($) {
  if ($j("#off-canvas-menu").length > 0) {
    "use strict";
    $j(document).bind('cbox_open', function() {
      $j('body').css("top", -$j('body').scrollTop());
      $j('body').addClass("no-scroll");
    }).bind('cbox_closed', function() {
      var top = parseInt($j('body').css("top").replace("px", ""))*-1;
      $j('body').removeAttr("style");
      $j('body').removeClass("no-scroll");
      $j('body').scrollTop(top);
    });

    // check if RTL mode
    var colorBoxMenuPosL = ($j("body").hasClass('rtl')) ? 'none' : '0';
    var colorBoxMenuPosR = ($j("body").hasClass('rtl')) ? '0' : 'none';

    $j("#off-canvas-menu-toggle").colorbox({
      inline: true,
      opacity: 0.55,
      transition: "none",
      arrowKey: false,
      width: "300",
      height: "100%",
      fixed: true,
      className: 'canvas-menu',
      top: 0,
      right: colorBoxMenuPosR,
      left: colorBoxMenuPosL,
      colorBoxCartPos: 0
    })
  } 

});
jQuery(function (e)
{
	e("#off-canvas-menu .expander-list").find("ul").hide().end().find(" .expander").text("+").end().find(".active").each(function ()
	{
		e(this).parents("li ").each(function ()
		{
			var t = e(this),
				o = t.find("> ul"),
				i = t.find("> .name .expander");
			o.show(), i.html("&minus;")
		})
	}).end().find(" .expander").each(function ()
	{
		var t = e(this),
			o = "+" === t.text(),
			i = t.parent(".name").next("ul");
		t.next("a");
		t.click(function ()
		{
			"block" == i.css("display") ? i.slideUp("slow") : i.slideDown("slow"), e(this).html(o ? "&minus;" : "+"), o = !o
		});
   
	});
       
}),jQuery(function (e){
  e('.name').click(function(){ 
    if(e(this).hasClass('open')){
      e(this).removeClass('open');
    }
    else{
      e(this).addClass('open');
    }
    var expanderSelector = "+" === e(this).find('.expander').text();
    e(this).find('.expander').html(expanderSelector ? "&minus;" : "+");
  });
  e('.expander').click(function(){
    if(e(this).parent().hasClass('open')){
    
      e(this).parent().removeClass('open'); 
    }
    else{
      e(this).parent().addClass('open');  
    }
  });
})




//end mobile

// desctop menu(popup)
function menu_popup(){
 "use strict";
    if ($j(".mainMenu").length > 0) {
       if (window.matchMedia('(max-width: 1025px)').matches){
         $j("header .mainMenu .navbar-nav > li").on('mouseenter mouseleave', function (e) {
         if ($j('ul', this).length) {
             var elm = $j('ul:first', this);
             var off = elm.offset();
             var l = off.left;
             var w = elm.width();
             var docH = $j(".container").height();
             var docW = $j(".container").width();

             var isEntirelyVisible = (l + w <= docW);

             if (!isEntirelyVisible) {
                 $j('ul',this).addClass('popup-left');
             } else {
                 $j('ul',this).removeClass('popup-left');
             }
         }
     });
    }
        
    } 
}



function productTabsCarousel(carousel,numberXl,numberLg,numberMd,numberSm,numberXs) {

  var windowW = window.innerWidth || $j(window).width();

  var slidesToShowXl = (numberXl > 0) ? numberXl : 6;
  var slidesToShowLg = (numberLg > 0) ? numberLg : 4;
  var slidesToShowMd = (numberMd > 0) ? numberMd : numberLg;
  var slidesToShowSm = (numberSm > 0) ? numberSm : numberMd;
  var slidesToShowXs = (numberXs > 0) ? numberXs : 1;

  var carousel = carousel;
  var speed = 500;

  if (carousel.parent().find('.carousel-products__button').length > 0) {

    carousel.slick({
      prevArrow: carousel.parent().find('.carousel-products__button .btn-prev'),
      nextArrow: carousel.parent().find('.carousel-products__button .btn-next'),
      dots: true,
      slidesToShow: slidesToShowXl,
      slidesToScroll: slidesToShowXl,
      settings: "unslick"
    });
  }
  else {
    carousel.slick({
      slidesToShow: slidesToShowXl,
      slidesToScroll: 1,
      speed: speed,
      settings: "unslick"
    });
  }


  fixCarouselHover(carousel);

};

// tabs
if($j('.nav-tabs--ys-center').length) {
  initTabsGallery();

  $j('.nav-tabs--ys-center .active a').trigger('click');
  $j(window).resize(function(){
    $j('.nav-tabs--ys-center a').unbind();
    initTabsGallery();
  });

}

function initTabsGallery(){
  $j('.nav-tabs--ys-center a').each(function(){
    $j(this).click(function(){
      $j(this).unbind();
      var tab = $j(this).attr("href");
      var clone = tab+"-clone";
      $j(tab).empty();
      $j(clone).children().clone().appendTo($j(tab));
      var $obj = $j(tab).find(".carouselTab");
      $obj.css("visibility", "hidden");
      if($obj.length) {
        setTimeout(function(){
          productCarousel($obj,6,4,3,2,1);
          $obj.hide();
          $obj.css("visibility", "visible");
          $obj.fadeIn(500);
        }, 5);
      }
    })
  });
}
//

// Listing Gallery
function initListingGalleryEvent() {
  $j('.coll-products-js').click(function(){
    $j(this).unbind();
    listingGalleryEventHandler();
  });
}
function listingGalleryEventHandler() {
  $j('.coll-gallery').empty();
  $j('.coll-gallery-clone').children().clone().appendTo('.coll-gallery');
  verticalCarousel($j('.coll-gallery .vertical-carousel-2'),20); //Collection sidebar item count
};
if($j('.coll-products-js').length) {
  if($j('.coll-products-js').hasClass('open')) {
    listingGalleryEventHandler();
  } else {
    initListingGalleryEvent();
  }
  $j(window).resize(function(){
    $j('.coll-products-js').unbind();
    initListingGalleryEvent();
    if($j('.coll-products-js').hasClass('open')) {
      listingGalleryEventHandler();
    }
  });
};

//Menu
var timerVar;
$j("nav").each(function(){
  if(!$j( this ).hasClass("navbar-vertical")) {
    $j( this ).find(".dropdown").each(function(){
      $j( this ).hover(
        function() {
          var $this = $j( this );
          var $obj = $this.find(".dropdown-menu");
          if($obj.length) {
            $obj.fadeOut(0);
            timerVar = setTimeout(function(){ 
              $this.addClass("active"); 
              $obj.fadeIn(0); // default is 200
              submenuXposition($obj);
              submenuYposition($obj);
              $j( window ).bind( "scroll", { obj: $obj }, menuScroll);
            }, 0); // default is 200
          }
        }, function() {
          var $this = $j( this );
          var $obj = $this.find(".dropdown-menu");
          clearTimeout(timerVar);
          $j( window ).unbind( "scroll", menuScroll);
          if($this.hasClass("active")){
            $obj.fadeOut(0); // default is 300
            setTimeout(removeActiveItem, 0, $this); // default is 300
          }
        }
      );
    });
  }
});
function submenuXposition($obj){
	var w_width = window.innerWidth;
	var o_position = $obj.offset().left;
	var o_width = $obj.outerWidth();
	var delta = parseInt(w_width - o_position - o_width - 25);
	
	if(delta < 0) {
		$obj.css("left", delta);
	}
}
function submenuYposition($obj){
	var w_height = window.innerHeight;
	var o_position = $j(".stuck-nav").hasClass("fixedbar") ? $obj.position().top : $obj.offset().top;
	var o_height = $obj.outerHeight();
	var delta = parseInt(w_height - o_position - o_height);
	if(delta < 0) {
		$obj.css({"max-height": o_height + delta - 25, "overflow": "auto"});
	}
}
function menuScroll(event) {
	event.data.obj.removeAttr("style");
	submenuXposition(event.data.obj);
	submenuYposition(event.data.obj)
}

function removeActiveItem(item){
  item.removeClass("active");
  item.removeAttr("style");
}

if($j( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).length) {
  $j( "nav .dropdown-toggle[href='" + window.location.pathname + "']" ).parent().addClass("selected");
}

//doubleTapToGo Menu
jQuery(function ($) {
    "use strict";
	$j('.responsive-menu .dropdown-mega-menu').doubleTapToGo();
});
//layout 9, product holder fullscreen
if($j(".l9-one-product-js").length) {
	l9rectangle();
	$j(window).resize(l9rectangle);
}
function l9rectangle() {
	var $obj = $j(".l9-one-product-js");
	$obj.find(".row").removeAttr("style");
	setTimeout(function(){
		var w_height = window.innerHeight;
		var y_pos = $obj.offset().top;
		var h_obj = $obj.outerHeight();
		var delta = parseInt(w_height - y_pos - h_obj);
		if(delta > 0) {
			$obj.find(".row").css("padding-bottom", delta);
		}
	}, 100);
}

// cart header
var $cart = $j(".cart");
$j(window).resize(headerCartSize);
function headerCartSize() {
  if ($cart.length) {
    $cart.find(".dropdown-menu").scrollTop(0)
    cartHeight();
  }
}
function cartHeight(){
  var $obj = $cart.find(".dropdown-menu");
  var w_height = window.innerHeight;
  var o_height = $obj.outerHeight();
  var delta = parseInt(w_height - o_height);
  if(delta < 0) {
    $obj.css({"max-height": o_height + delta, "overflow": "auto", "overflow-x": "hidden" });
  }
}

// Parallax

jQuery(function($j) {

    "use strict";
    if ($j('.content--parallax, .carusel--parallax').length) {
		$j('.content--parallax, .carusel--parallax').each(function() {
			var attr = $j(this).attr('data-image');		
			$j(this).css({'background-image': 'url('+attr+')'}).parallax("50%", 0.01);
		})
	}
	
  	
	
});

		

/* product hover */
if($j('.no-touch .product--zoom').length) {
  initProductHover();
  $j(window).bind('reinitProductHover', function(){
    if($j('.no-touch .product--zoom').length) {
      initProductHover();
    }
  });
}
function initProductHover(){
  $j('.no-touch .product--zoom').unbind();
  $j('.no-touch .product--zoom').each(function(){
    $j(this).hover(
      function(e) {
        if(window.innerWidth > 1298 && $j('.row-view').length == 0) {
//          $j(this).css({'height': $j(this).innerHeight() + 'px'});
//           $j(this).addClass('hovered');
        }
      }, function() {
        if(window.innerWidth > 1298 && $j('.row-view').length == 0) {
//          $j(this).css({'height': ''});
//           $j(this).removeClass('hovered');
        }
      }
    );
  })
}

/* products options */
function initProductOptions(){
  if($j('.productitem-color-js').length){
    $j('.productitem-color-js').each(function(){
      $j(this).find('a').each(function(){
        $j(this).unbind();
        $j(this).click(function(e){
          e.preventDefault();
          var $this = $j(this);
          if($this.parent().hasClass('active')) return false;
          setNewData($this);

          var val = '.' + $this.attr("href") + '-js';
          var $pr_parent = $j('.'+$this.attr('pr_id'));
          if($pr_parent.find('.options-swatch--size').length) {
            $pr_parent.find('.options-swatch--size li').each(function(){
              $j(this).hide();
              $j(this).removeClass('active');
            });
          };
          if($pr_parent.find(val).length) {
            $pr_parent.find(val).first().addClass('active');
            $pr_parent.find(val).show();
          }
        })
      })
    })
  }
  if($j('.productitem-size-js').length){
    $j('.productitem-size-js').each(function(){
      $j(this).find('a').each(function(){
        $j(this).unbind();
        $j(this).click(function(e){
          e.preventDefault();
          var $this = $j(this);
          if($this.parent().hasClass('active')) return false;
          setNewData($this);
        })
      })
    })
  }
}
function setNewData($this){
  $this.parent().parent().find(".active").removeClass('active');
  $this.parent().addClass('active');

  var $pr_parent = $j('.'+$this.attr('pr_id'));

  if($pr_parent.find('.product__inside__carousel').length == 0) {
    var img_src = $this.attr('img');
    if(img_src != '') $pr_parent.find('img').first().attr('src', img_src);
  }
  $pr_parent.find('.addtocart-js').attr('onclick', 'Shopify.addItem('+$this.attr('var_id')+', 1)');
  if($j('.button_massage').length) $pr_parent.find('.addtocart-js').html($j('.button_massage').html());

  $pr_parent.find('.product__inside__price').html('<span class="money">'+$this.attr('price')+'</span>');
  $j('.currency .active').trigger('click');
}
initProductOptions();
$j(window).bind('reinitProductOptions', initProductOptions);

/* Multi menu position */
var $mainMenu = $j(".mainMenu");
if($mainMenu.find('.dropdown-mega-menu').length) {
  $mainMenu.find('.dropdown-mega-menu > ul:not(.image-links-layout)').each(function(){
    $j(this).find('a').each(function(){
      $j(this).hover(
        function(){
          var $this = $j(this);
          if($this.parent().find('ul').length) {
            var $ul = $this.parent().find('ul').first();
            var ow = $ul.innerWidth();
            var ox = $ul.offset().left;
            var s = ow + ox;
            
            var oh = $ul.innerHeight();
            var oy = $ul.offset().top;
            var sh = oh + oy;
            
            var w = window.innerWidth;
            var h = 0;
            var _par = null;
            
            if($ul.hasClass('megamenu__submenu')) {
              var _parent = false;
              if($ul.parent().parent().hasClass('megamenu')) {
                return false;
              }
              else if($ul.parent().parent().parent().parent().hasClass('megamenu')) {
                _par = $ul.parent().parent().parent().parent();
                w = _par.offset().left + _par.innerWidth();
                h = _par.offset().top + _par.innerHeight();
                h -= sh;
                if(h < 0) $ul.css('top', h-5);
              }
              else if($ul.parent().parent().parent().parent().parent().parent().hasClass('megamenu')) {
                _par = $ul.parent().parent().parent().parent().parent().parent();
                w = _par.offset().left + _par.innerWidth();
                h = _par.offset().top + _par.innerHeight();
                h -= sh;
                if(h < 0) $ul.css('top', h-5);
              }
            }
            if(w < s) $ul.addClass('popup-left');
          }
        },
        function(){
      	}
      )
    })
  })
}
$j(window).resize(function(){
  if($j('.popup-left').length) {
    $j('.popup-left').each(function(){
      $j(this).removeClass('popup-left');
      $j(this).removeAttr('style');
    })
  }
});



$j('.nav-item').click(function(){
          (function() {

            // Initialize

            var bLazy = new Blazy();

        })();
});
$j('.infinitybutton').click(function(){
	var bLazy = new Blazy();
  	bLazy.revalidate();
 	bLazy.load();
});


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
if (links[i].hostname !== window.location.hostname && links[i].hostname != "") {
    links[i].target = '_blank';
}
}


  // store values on an array based on the SETTINGS PICKUP SKU LISTS
  var pickup_sku_list = "";
  var pickup_only_sku_list = "144256,148885,144258,873-0028,144261,166366,170364,Service-A1,Service-A2,Service-A3,Service-A4,Service-B1,Service-B3,Service-B4,Service-B5,Service-B6,Service-B7,Service-B8,Service-B9,Service-C1,Service-C2,Service-C3,104121,104068,107319,109911,100949,101667,108093,103243,49-2285,49-2286,49-2261,49-2269,Service-D1,Service-D2,Service-D3,Service-D4,Service-D5,Bstone190,Bstone180,PR6180SET,PR6190SET,MX33Set,MAXXRear11019,MAXXFRT21,MAXXRear18,Bstone190SET,Bstone180SET,Service-B8,Service-B9,Service-B10,Q5S180SET,Q5S190SET,RS4180SET,RS4190SET,GPR180SET,GPR190SET,Q5180SET,Q5190SET,87-4914,87-4916,87-4917,87-4902,87-4904,87-4900,87-4903,87-4909,87-4905,87-4915,87-4906,87-4918,87-4913,87-4912,87-4919,87-4908,87-4907,87-4901,87-4910,87-93745,87-93744,87-93747,87-93762,87-93740,87-93743,87-93749,87-93755,87-93753,87-93754,87-93751,87-93759,87-93758,87-93750,87-93757,Service-A5,Service-A6,Service-A7";

  // store values on an array based on the pickup_sku_list VARIABLES
  var pickup_sku_list_arr = [];
  var pickup_only_sku_list_arr = [];
  var pickup_sku_list_arr = pickup_sku_list.split(",");
  var pickup_only_sku_list_arr = pickup_only_sku_list.split(",");

  // array for trimmed values of the PICKUP SKU LISTS
  var pickup_sku_list_arr2 = [];
  var pickup_only_sku_list_arr2 = [];

  var item_onCart_vid = [];
  var item_onCart = [];
  var pickup_onCart = [];
  var pickupOnly_onCart = [];


  // trim each array values to remove whitespaces
  for(var pickVal in pickup_sku_list_arr)
  {
      var thisPickVal = pickup_sku_list_arr[pickVal];
      thisPickVal = thisPickVal.trim();
      pickup_sku_list_arr2.push(thisPickVal);
  }

  for(var pickOnVal in pickup_only_sku_list_arr)
  {
      var thisPickOnVal = pickup_only_sku_list_arr[pickOnVal];
      thisPickOnVal = thisPickOnVal.trim();
      pickup_only_sku_list_arr2.push(thisPickOnVal);
  }

  // remove null, undefined and "" on array values
  pickup_sku_list_arr2 = pickup_sku_list_arr2.filter(function(e){ return e === 0 || e });
  pickup_only_sku_list_arr2 = pickup_only_sku_list_arr2.filter(function(e){ return e === 0 || e });

  const pickup_button_content = $j('#proceed-pickup').html();
  const pickupLoader = function(loading=true) {
    const loader = `<svg fill="#fff" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></path></svg>`;
    if(loading && !$j('#proceed-pickup svg').length) {
      $j('#proceed-pickup').addClass('disabled');
      $j('#proceed-pickup').append(loader);
    } else {
      $j('#proceed-pickup svg').remove();
    }
  }
  
  var params = {
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(line_item) {
      let hasPickup = false;
      var getPickupList = $j('#proceed-pickup').data('elpickup');
      for (var item in line_item.items) {
        let sku = line_item.items[item].sku;
        item_onCart.push(sku);
        item_onCart_vid.push(line_item.items[item].variant_id);
        if(getPickupList.includes(sku)){
          pickup_onCart.push(sku);
        }
        if(pickup_only_sku_list_arr2.includes(sku)){
          pickupOnly_onCart.push(sku);
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);

//         console.log("pickup on CART:", pickup_onCart);
//         console.log("pickup ONLY on CART:", pickupOnly_onCart);
//         console.log("items on CART:", item_onCart);
//         console.log("Pickup ARR:", pickup_sku_list_arr2);
//         console.log("Pickup ONLY ARR:", pickup_only_sku_list_arr2);

  // ON CART PAGE: PICKUP ORDER BUTTON
  $j('#proceed-pickup').on('click',function(e){
    e.preventDefault();
    let hasShip = false;
    for (var i in item_onCart) {
      // check if cart page also contains SHIPPING ONLY items
      if(!pickup_onCart.includes(item_onCart[i]) && !pickupOnly_onCart.includes(item_onCart[i])){
        hasShip = true;
      }
    } 
    // if cart page contains SHIPPING ONLY items
    if(hasShip)
    {
      $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
      
      if(pickup_onCart.length <= 0 && pickupOnly_onCart.length <= 0)  // if it contains SHIPPING ONLY items and NO PICKUP ELIGIBLE items
      {
        $j('.pickupButton-pickupAndShipItems').hide();  // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button
        $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.shipButton').hide(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        $j('.noship').hide(); // SHIP ORDER: Has no SHIPPING item(s)
        $j('.nopickup').show(); // PICKUP ORDER: has NO PICKUP item(s)
        $j('.pickupButton').show(); // PICKUP ORDER: Modal Header Title: PICKUP ORDER
      }
      else  // ELSE if it contains SHIPPING ONLY items AND any PICKUP ELIGIBLE items
      {
        $j('.shipButton-pickupAndShipItems').hide();  // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.shipButton').hide(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
        $j('.noship, .nopickup').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
        $j('.pickupButton-pickupAndShipItems').show(); // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').show(); // PICKUP ORDER: Yes, I Understand button
        $j('.pickupButton').show(); // PICKUP ORDER: Modal Header Title: PICKUP ORDER
      } 
    } 
    // ELSE if cart page DOES NOT CONTAIN SHIPPING ONLY items and it's all PICKUP ELIGIBLE items
    else 
    {
      $j('#proceedPickup').click(); // next function
    }
  });
 
  $j('#pickup-button, #pick-up-now button').on('click',function(e){
    e.preventDefault();
    let qty = $j('#pickup-qty').val();
    let variant_id = $j(this).data('variantid');
    let line_items = [{variant_id: variant_id, quantity: qty}];
    $j.ajax({
      url: 'https://images.motorhelmets.com/shopify/draft-pickup-order.php',
      type: 'POST',
      dataType: 'json',
      headers: {
        'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
      },
      data: {line_items: line_items, store: 'haustrom'},
      beforeSend: function () {
        pickupLoader();
      },
      success: function (data) {
        let out = JSON.parse(data);
        let draft_order = out.draft_order;
        if("error" in draft_order){
          console.log("ERROR",draft_order.error);
        } else if("invoiceUrl" in draft_order){
          window.location.href = draft_order.invoiceUrl;
        }
        pickupLoader(false);
      },
      error: function(data){
        pickupLoader(false);
        $j('#pickupOptionModal').modal('hide');
        $j('#errorServerModal').modal('show');
      }
    });
  });

  // after the POP-UP MESSAGE: Yes, I Understand, go to checkout for PICKUP
  $j('#proceedPickup').on('click',function(e){
    var cartNote = $j('#note').val() ? $j('#note').val() : 'In-Store Pickup (Fullerton CA)';
    var discPercent = "15";
    var discCode = "15OFFPICKUP23";     
    e.preventDefault();
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(line_item) {
        let draftItem = [];
        let rem_item = {};
        let back_item = {};
        for (var item in line_item.items) {
          let sku = line_item.items[item].sku;
          if(pickup_onCart.includes(sku) || pickupOnly_onCart.includes(sku)){
            draftItem.push({ variant_id: line_item.items[item].variant_id, quantity: line_item.items[item].quantity });
            back_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
            rem_item[line_item.items[item].variant_id] = 0;
            toCookie(line_item.items[item].variant_id+":"+line_item.items[item].quantity);
          }
        }
        pickupLoader();
        
        $j.ajax({
          url: 'https://images.motorhelmets.com/shopify/draft-pickup-order.php',
          type: 'POST',
          headers: {
            'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
          },
          data: {line_items: draftItem, note: cartNote, dper: discPercent, dcode: discCode, store: 'haustrom'},
          beforeSend: function () {
            pickupLoader();
          },
          success: function (data) {
            // let out = JSON.parse(data);
            let out = data;
            let draft_order = out.draft_order;
            let inUrl = draft_order.invoiceUrl;
            console.log("CUSTOMER: ",draft_order.customer);
            if("error" in draft_order){
            	console.log("ERROR ERROR ERROR ERROR ERROR");
              console.log("ERROR",draft_order.error);
               console.log("STEP 1: ", "This happened.");
               // console.log("CUSTOMER: ",draft_order.customer);
              jQuery.post('/cart/update.js', {updates: back_item});
            } else if("invoiceUrl" in draft_order){
              console.log("STEP 2: ", "This happened.");
              console.log("INVOICE URL: ", inUrl);
              // console.log("CUSTOMER: ",draft_order.customer);
              // setTimeout(function(){
                window.location.href = draft_order.invoiceUrl;
              // },1500);
              
            }
            pickupLoader(false);

          },
          error: function(data){
            jQuery.post('/cart/update.js', {updates: back_item});
            console.log("STEP 3: ", "This happened.");
            console.log("ERROR",data);
            pickupLoader(false);
            $j('#errorServerCartModal').modal('show');
          }
        });

        // $j.ajax({
        //   url: 'https://osomnimedia.com/api/shopify-apps/requests/draft-pickup-delete-HAUS.php',
        //   type: 'POST',
        //   dataType: 'json',
        //   data: {draft_order_id: '582237257805', store: 'haustrom'},
        //   success: function (data) {
        //     let out = JSON.parse(data);
        //     console.log("STEP 4: ", "This happened.");
        //   },
        //   error: function(data){
        //     console.log("ERROR",data);
        //     console.log("STEP 5: ", "This happened.");
        //   }
        // });
        // jQuery.post('/cart/update.js', {updates: rem_item}); // remove the product variant on the cart
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
        console.log("STEP 6: ", "This happened.");
        jQuery.post('/cart/update.js', {updates: back_item});
      }
    };
    jQuery.ajax(params);
    console.log("STEP 7: ", "This happened.");
    // jQuery.post('/cart/update.js', {updates: rem_item}); // remove the product variant on the cart
  });
  
  // ON CART PAGE: SHIP ORDER BUTTON 
  $j('#proceed-ship').on('click',function(e){
    e.preventDefault();
    let hasPickup = false;
    let hasPickupOnly = false;
    for (var i in item_onCart) {
    	// check if cart page also contains SHIPPING ONLY items
      // if(pickup_onCart.includes(item_onCart[i]) && pickupOnly_onCart.includes(item_onCart[i])){
      //   hasShip = true;
      // }
      if(pickupOnly_onCart.includes(item_onCart[i])){
        hasPickupOnly = true;
      }
      if(pickup_onCart.includes(item_onCart[i])){
        hasPickup = true;
      }
      console.log(item_onCart[i]);
    }
    console.log("pickupOnly_onCart: ", pickup_only_sku_list);
    console.log("hasPickupOnly: ", hasPickupOnly);
    console.log("hasPickup: ", hasPickup);
    if(hasPickupOnly && hasPickup)
    {
      $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
      $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
      $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button
      $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
      $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
      $j('.shipButton-pickupOnly').show(); // SHIP ORDER: Has Pickup Only item(s)
      $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
      $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
    }
    else if(hasPickup)
    {
      $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
      $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
      $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button 
      $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
      $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
      $j('.shipButton-pickupAndShipItems').show(); // SHIP ORDER: Has Eligible for Pickup item(s)
      $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
      $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
    } 
    else if(hasPickupOnly)
    {
      $j('#pickupConfirmModal').modal('show'); // show warning prompt modal
      if(pickupOnly_onCart.length == item_onCart.length ) 
      {
        $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button  
        $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.shipButton-pickupAndShipItemsButton').hide(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton-pickupOnly').hide(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.nopickup').hide(); // PICKUP ORDER: has NO PICKUP item(s)
        $j('.noship').show(); // SHIP ORDER: Has no SHIPPING item(s)
        $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
      } 
      else 
      {
        $j('.pickupButton-pickupAndShipItems').hide(); // PICKUP ORDER: Has Shipping Only item(s)
        $j('.pickupButton-pickupAndShipItemsButton').hide(); // PICKUP ORDER: Yes, I Understand button  
        $j('.shipButton-pickupAndShipItems').hide(); // SHIP ORDER: Has Eligible for Pickup item(s)
        $j('.nopickup, .noship').hide(); // SHIP ORDER: Has no SHIPPING item(s) or no PICKUP item(s)
        $j('.shipButton-pickupOnly').show(); // SHIP ORDER: Has Pickup Only item(s)
        $j('.shipButton-pickupAndShipItemsButton').show(); // SHIP ORDER: Yes, I Understand button
        $j('.shipButton').show(); // SHIPPING ORDER: Modal Header Title: SHIPPING ORDER
      }
    }
    else 
    {
      // $j('#proceedShip').click(); // next function
      window.location.href = "/checkout";
    }
  });

  // after the POP-UP MESSAGE: Yes, I Understand, go to checkout for SHIP
  var pickrem_item = {};
  $j('#proceedShip').on('click',function(e){
    e.preventDefault();
    var params = {
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      beforeSend: function () {
        // preloader();
      },
      success: function(line_item) {
        // preloader("off");
        let draftItem = [];
        let rem_item = {};
        let back_item = {};
        let pickback_item = {};
        // let checkOrder = checkout.order;
        for (var item in line_item.items) {
          let sku = line_item.items[item].sku;
          if(pickupOnly_onCart.includes(sku)){
           rem_item[line_item.items[item].variant_id] = 0;
           pickback_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
          }
          else
          {
             pickrem_item[line_item.items[item].variant_id] = 0;
             draftItem.push({ variant_id: line_item.items[item].variant_id, quantity: line_item.items[item].quantity });
             back_item[line_item.items[item].variant_id] = line_item.items[item].quantity;
             toCookie(line_item.items[item].variant_id+":"+line_item.items[item].quantity);
          }
        }
         $j.ajax({
          url: 'https://images.motorhelmets.com/shopify/draft-ship-orders.php',
          type: 'POST',
          dataType: 'json',
          headers: {
            'X-Pickup-Secret': 'mh_sec_e8b417c2f09d4351a96c3482701bcf5e93a7d182'
          },
          data: {line_items: draftItem, store: 'haustrom'},
          beforeSend: function () {
            // preloader();
          },
          success: function (data) {
            let draft_order = data.draft_order;
            let inUrl = draft_order.invoiceUrl;
            if("error" in draft_order){
              console.log("ERROR",draft_order.error);
              console.log("STEP 1: ", "This happened.");
              jQuery.post('/cart/update.js', {updates: back_item});
            } else if("invoiceUrl" in draft_order){
              console.log("STEP 2: ", "This happened.");
              console.log("INVOICE URL: ", inUrl);
              window.location.href = draft_order.invoiceUrl;
            }
            // preloader("off");

          },
          error: function(data){
            jQuery.post('/cart/update.js', {updates: back_item});
            console.log("STEP 3: ", "This happened.");
            console.log("ERROR",data);
            // preloader("off");
            $j('#errorServerCartModal').modal('show');
          }
        });
        
        // jQuery.post('/cart/update.js', {updates: rem_item}).always(function() {
        //    window.location.href = "/checkout";
        // });
      },
      error: function(XMLHttpRequest, textStatus) {
        console.log(XMLHttpRequest, textStatus);
         jQuery.post('/cart/update.js', {updates: back_item});
         jQuery.post('/cart/update.js', {updates: pickback_item});
      }
    };
    jQuery.ajax(params);
    if(pickrem_item.length) jQuery.post('/cart/update.js', {updates: pickrem_item}); // remove the pickup only product on cart page
   
  });
  
  $j('#shipit').on('click',function(e){
    $j('.shopify-payment-button button.shopify-payment-button__button').click();
  });         
          
    function toCookie(data){
    let cookiename = 'pickup_product';
    try {
      let item = data;
      let items = getCookie($j.cookie(cookiename));
      items = (items==null) ? items+"::" : '';
      $j.cookie(cookiename, items+item, { expires : 7, path: '/' });
    }
    catch (err) {
      console.log(err);
    }
  }

  function getCookie(c) {
    return String(c);
  }                 
